import { useContext } from "react";
import permissionContext from "../../_helper/permissions";


const Can = ({ permission, children }) => {
  const {hasPermission}=useContext(permissionContext)

  if (!hasPermission(permission)) return null;

  return children;
};

export default Can;